import React from 'react';
import { HiArrowLeft } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { images } from '../../constants';

const ChatHeader = ({ userInfo }) => {
  const navigate = useNavigate();

  return (
    <div className="app__ask-ai-top-bar">
      <button 
        className="back-button"
        onClick={() => {
          navigate('/');
        }}
        title="Go back to home"
      >
        <HiArrowLeft />
      </button>
      <div className="app__ask-ai-title-compact">
        <img src={images.faceLogo} alt="Lovish" className="title-avatar" />
        <div className="title-text">
          <h2>Chat with Lovish</h2>
          <span className="subtitle">
            {userInfo.name ? (
              <>
                Excited to chat with you, <span className="user-name-glow">{userInfo.name}</span>!
              </>
            ) : (
              'Excited to chat with you!'
            )}
          </span>
        </div>
      </div>
      <div className="spacer"></div>
    </div>
  );
};

export default ChatHeader; 